<template>
  <nav :class="$style['nav']">
    <NavigationLink
      v-for="(item, index) in nav"
      :key="item.path"
      :to="{ name: item.path }"
      :class="$style['link']"
    >
      <NavigationLinkContent
        :icon-name="item.icon"
        :nav-label="''"
        :class="$style['link--icon']"
      />
      <Paragraph5 :class="index === activeIndex ? $style['link--label-selected'] : $style['link--label']">
        {{ $t('nav.' + item.label) }}
      </Paragraph5>
    </NavigationLink>

    <a
      v-if="countryParams.CONTACT_URL !== '' && !blockedInExecution"
      :class="$style['link--default']"
      :href="countryParams.CONTACT_URL"
      target="_blank"
    >
      <NavigationLinkContent
        :class="$style['link']"
        :icon-name="'IconMailHeart'"
        :nav-label="''"
      />
    </a>

    <a
      v-if="countryParams.FAQ_URL !== ''"
      :class="$style['link--default']"
      :href="countryParams.FAQ_URL"
      target="_blank"
    >
      <NavigationLinkContent
        :class="$style['link']"
        :icon-name="'IconQuestion'"
        :nav-label="''"
      />
    </a>
  </nav>
</template>

<script lang="ts" setup>
import { Paragraph5 } from '~/components-daisy/typography';
import type { NavItem } from './NavItem.type';

const countryParams = useCountryParams();

type Props = {
  nav: NavItem[];
};

const props = defineProps<Props>();

const store = useFloristInfoStore();
const { floristInfo: floristInfo } = storeToRefs(store);
const { blockedInExecution } = floristInfo.value?.floristActivity ?? {};

const route = useRoute();
const activeIndex = computed(() => props.nav.findIndex((item) => route.name === item.path));
</script>

<style lang="postcss" module>
@media (min-width: 901px) {
  .nav {
    display: none;
  }
}

@media (max-width: 900px) {
  .nav {
    width: 100%;
    min-height: 82px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: var(--color-mono-100);
    box-shadow: var(--shadow-800);
    gap: var(--space-100) var(--space-50);
    padding: var(--space-300) 0;
    @media (max-width: 450px) {
      flex-wrap: wrap;
      justify-content: flex-start;
      padding: 20px;
    }
  }
}

.link {
  &--default {
    text-decoration: none;
    width: 42px;
    height: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--color-mono-500);
  }
  &--label {
    text-align: center;
    font-size: 0px;
    transition: font-size 500ms;
  }
  &--label-selected {
    text-align: center;
    font-size: var(--font-200-size);
    transition: font-size 500ms;
  }
}
</style>
